import { Outlet, useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import { clearSession } from '../auth/session';
import { logoutShared } from '../api';

export default function PayrollLayout() {
  const navigate = useNavigate();

  async function logout() {
    await logoutShared();
    clearSession();
    navigate('/', { replace: true });
  }

  return (
    <AppShell onLogout={logout}>
      <Outlet />
    </AppShell>
  );
}
